import { render, staticRenderFns } from "./transcript.vue?vue&type=template&id=03fabd5c&scoped=true&"
import script from "./transcript.ts?vue&type=script&lang=ts&"
export * from "./transcript.ts?vue&type=script&lang=ts&"
import style0 from "./transcript.scss?vue&type=style&index=0&id=03fabd5c&lang=scss&scoped=true&"
import style1 from "./transcript.vue?vue&type=style&index=1&id=03fabd5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fabd5c",
  null
  
)

export default component.exports